import React from 'react';
import { GFLessonResource } from '../../../models/models';

type Props = {
  resource: GFLessonResource|null,
}

const Image: React.FunctionComponent<Props> = ({ resource }) => {
  if (! resource) {
    return null;
  }

  return <img src={resource.url} className="resource-image"/>;
};

export default Image;
